import { MobiDocument } from './MobiDocument';

export class TypeActivite extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private categorie_nom: string;
    private intitule: string;


    public constructor(activite: any) {
        super()
        this._id = activite._id;
        this._rev = activite._rev;
        this.id = activite.id;
        this.categorie_nom = activite.categorie_nom;
        this.intitule = activite.intitule;
    }


    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getCategorie_nom(): string {
        return this.categorie_nom;
    }

    public setCategorie_nom(categorie_nom: string): void {
        this.categorie_nom = categorie_nom;
    }

    public getIntitule(): string {
        return this.intitule;
    }

    public setIntitule(intitule: string): void {
        this.intitule = intitule;
    }
}